// Copyright (c) 2016 Deere & Company

import * as fetchService from '../../shared/services/fetch';
import {handleError} from '../../shared/services/error-handlers';

const basePath = '/api';

export async function getAppConfig() {

    try {

        const endPoint = `${basePath}/app-config`;
        const response = await fetchService.anonFetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

}



// WEBPACK FOOTER //
// ./src/app-config/repositories/index.js